import { render } from "./Pagenation.vue?vue&type=template&id=2c23e7dc&scoped=true"
import script from "./Pagenation.vue?vue&type=script&lang=js"
export * from "./Pagenation.vue?vue&type=script&lang=js"

import "./Pagenation.vue?vue&type=style&index=0&id=2c23e7dc&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c23e7dc"]])

export default __exports__